// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Network = require("./network");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Cta_arrowSvg = require("./assets/cta_arrow.svg");
var Typ1_iconSvg = require("./assets/typ1_icon.svg");
var Typ2_iconSvg = require("./assets/typ2_icon.svg");
var Start_iconSvg = require("./assets/start_icon.svg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var Start_gas_bgSvg = require("./assets/start_gas_bg.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var wizard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputHeaderHead = Css.style(/* :: */[
      Css.margin4(Css.px(30), Css.px(0), Css.px(25), Css.px(0)),
      /* [] */0
    ]);

var inputHeaderText = Css.style(/* :: */[
      Css.fontWeight(700),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "F66297"
            ]),
        /* :: */[
          Css.margin4(Css.px(15), Css.px(20), Css.px(25), Css.px(20)),
          /* :: */[
            Css.zIndex(2),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.justifyContent(/* center */98248149),
          /* [] */0
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(10), Css.px(5), Css.px(10)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var initialBodyImgHigh = Css.style(/* :: */[
      Css.margin4(Css.px(2), Css.px(7), Css.px(2), Css.px(7)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.borderStyle(Css.solid),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(15), Css.px(0), Css.px(15), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(20)),
        /* :: */[
          Css.fontSize(Css.px(28)),
          /* :: */[
            Css.maxWidth(Css.px(140)),
            /* :: */[
              Css.borderRadius(/* `px */[
                    25096,
                    50
                  ]),
              /* :: */[
                Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                      5194459,
                      "F492BD"
                    ]),
                /* :: */[
                  Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                  /* :: */[
                    Css.boxSizing(/* borderBox */9307263),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var smallArrow = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.margin2(Css.px(0), Css.px(8)),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var typIcons = Css.style(/* :: */[
      Css.margin2(Css.px(10), Css.px(8)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                1.2,
                1.2
              ]
            ]),
        /* [] */0
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.margin4(Css.px(30), Css.px(8), Css.px(0), Css.px(0)),
              /* :: */[
                Css.width(Css.px(140)),
                /* :: */[
                  Css.justifyContent(/* spaceAround */-485895757),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(0)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.width(Css.px(22)),
          /* :: */[
            Css.height(Css.px(22)),
            /* :: */[
              Css.borderRadius(/* `percent */[
                    -119887163,
                    50.0
                  ]),
              /* :: */[
                Css.background(/* `hex */[
                      5194459,
                      "FCEBEC"
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxElSmall = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(8), Css.px(0), Css.px(0)),
      /* :: */[
        Css.fontSize(Css.px(24)),
        /* :: */[
          Css.width(Css.px(10)),
          /* :: */[
            Css.height(Css.px(10)),
            /* :: */[
              Css.borderRadius(/* `percent */[
                    -119887163,
                    50.0
                  ]),
              /* :: */[
                Css.background(/* `hex */[
                      5194459,
                      "FCEBEC"
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var rocketBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.position(Css.relative),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(/* center */98248149),
            /* [] */0
          ]
        ]
      ]
    ]);

var rocket = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(24)),
          /* :: */[
            Css.width(Css.px(160)),
            /* :: */[
              Css.height(Css.px(160)),
              /* :: */[
                Css.borderRadius(/* `percent */[
                      -119887163,
                      50.0
                    ]),
                /* :: */[
                  Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var startIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  50.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(30)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var startGas = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.0,
                  1.0
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  50.0
                ]),
            /* :: */[
              Css.top(Css.px(163)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var selectorBox = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.height(Css.px(200)),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.maxWidth(Css.px(150)),
            /* :: */[
              Css.justifyContent(/* center */98248149),
              /* :: */[
                Css.border(Css.px(4), /* solid */12956715, /* `hex */[
                      5194459,
                      "FFEEEF"
                    ]),
                /* :: */[
                  Css.borderRadius(Css.px(10)),
                  /* :: */[
                    Css.margin(Css.px(10)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var selectorBoxHigh = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.height(Css.px(200)),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.maxWidth(Css.px(150)),
            /* :: */[
              Css.justifyContent(/* center */98248149),
              /* :: */[
                Css.border(Css.px(4), /* solid */12956715, /* `hex */[
                      5194459,
                      "EEBFC2"
                    ]),
                /* :: */[
                  Css.borderRadius(Css.px(10)),
                  /* :: */[
                    Css.margin(Css.px(10)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

function nextButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(160)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(35), Css.px(18), Css.px(10), Css.px(18)),
                  Theme.greenButtonRaw
                ]
              ]
            ]);
}

function nextButton2() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(160)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(5), Css.px(18), Css.px(10), Css.px(18)),
                  /* :: */[
                    Css.zIndex(2),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

function selectButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(200)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(18), Css.px(10), Css.px(18)),
                  Theme.greenButtonRaw
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* wizard */wizard,
  /* inputHeader */inputHeader,
  /* inputHeaderHead */inputHeaderHead,
  /* inputHeaderText */inputHeaderText,
  /* initialBody */initialBody,
  /* initialBodyImg */initialBodyImg,
  /* initialBodyImgHigh */initialBodyImgHigh,
  /* flexList */flexList,
  /* inputField */inputField,
  /* someLink */someLink,
  /* smallArrow */smallArrow,
  /* typIcons */typIcons,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* horizonBoxElSmall */horizonBoxElSmall,
  /* rocketBox */rocketBox,
  /* rocket */rocket,
  /* startIcon */startIcon,
  /* startGas */startGas,
  /* selectorBox */selectorBox,
  /* selectorBoxHigh */selectorBoxHigh,
  /* nextButton */nextButton,
  /* nextButton2 */nextButton2,
  /* selectButton */selectButton
];

function text(prim) {
  return prim;
}

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      return 0;
    } else {
      throw exn;
    }
  }
}

function checkForInt(x) {
  var x2 = convToInt(x);
  if (x2 > 0 && x2 < 200) {
    return x2;
  } else {
    return 0;
  }
}

function turnBackToString(theInt) {
  if (theInt !== 0) {
    return String(theInt);
  } else {
    return "0";
  }
}

var component = ReasonReact.reducerComponent("ResetExec");

function make(step, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var match = +(self[/* state */2][/* levelSelect */3] > 0);
      if (match !== 0) {
        ReasonReact.Router[/* push */0]("/wizard/4");
      }
      var match$1 = +(self[/* state */2][/* imageSelect */2] > 0);
      if (match$1 !== 0) {
        ReasonReact.Router[/* push */0]("/wizard/3");
      }
      var match$2 = +(self[/* state */2][/* weight */1] > 0);
      if (match$2 !== 0) {
        ReasonReact.Router[/* push */0]("/wizard/2");
      }
      window.scrollTo(0, 0);
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */5];
      var step1 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Aktuelles Gewicht"), React.createElement("div", {
                className: inputHeaderText
              }, "Hey, trage jetzt dein aktuelles Gewicht ein:"), React.createElement("input", {
                className: inputField,
                autoFocus: true,
                pattern: "[0-9]*",
                placeholder: "Kg",
                type: "number",
                value: state[/* weightInput */0],
                onKeyDown: (function ($$event) {
                    if ($$event.keyCode === 13) {
                      $$event.preventDefault();
                      return Curry._1(send, /* Step1InputEnterKeyDown */1);
                    } else {
                      return Curry._1(send, /* Step1InputOtherKeyDown */0);
                    }
                  }),
                onChange: (function ($$event) {
                    return Curry._1(send, /* ChangeWeight */Block.__(0, [$$event.target.value]));
                  })
              }), match ? React.createElement("div", {
                  className: "failure"
                }, match[0]) : null, React.createElement("button", {
                className: nextButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step1Exec */2);
                  })
              }, "Weiter", React.createElement("img", {
                    className: smallArrow,
                    alt: "arrow",
                    src: Cta_arrowSvg
                  })), React.createElement("div", {
                className: horizonBox
              }, React.createElement("div", {
                    className: horizonBoxEl
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  })));
      var match$1 = state[/* imageSelect */2];
      var className21 = match$1 !== 1500 ? selectorBox : selectorBoxHigh;
      var match$2 = +(state[/* imageSelect */2] === 1300);
      var x = match$2 !== 0 ? selectorBoxHigh : selectorBox;
      var match$3 = state[/* error */5];
      var step2 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Ausgangsform"), React.createElement("div", {
                className: initialBody
              }, React.createElement("div", {
                    className: className21,
                    onClick: (function () {
                        return Curry._1(send, /* Step2ImageSelect */Block.__(1, [1500]));
                      })
                  }, React.createElement("img", {
                        className: typIcons,
                        alt: "typ1",
                        src: Typ1_iconSvg
                      })), React.createElement("div", {
                    className: x,
                    onClick: (function () {
                        return Curry._1(send, /* Step2ImageSelect */Block.__(1, [1300]));
                      })
                  }, React.createElement("img", {
                        className: typIcons,
                        alt: "typ2",
                        src: Typ2_iconSvg
                      }))), React.createElement("div", {
                className: inputHeaderText
              }, "Schätze nun anhand der Skizzen deine Ausgangsform ein."), match$3 ? React.createElement("div", {
                  className: "failure"
                }, match$3[0]) : null, React.createElement("button", {
                className: nextButton2(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step2Exec */3);
                  })
              }, "Weiter", React.createElement("img", {
                    className: smallArrow,
                    alt: "arrow",
                    src: Cta_arrowSvg
                  })), React.createElement("div", {
                className: horizonBox
              }, React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxEl
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  })));
      var step3 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Belastungsumfang"), React.createElement("div", {
                className: inputHeaderText
              }, "Wähle deinen Belastungsumfang aus."), React.createElement("button", {
                className: selectButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step3LevelSelect */Block.__(2, [30]));
                  })
              }, "Anfänger"), React.createElement("button", {
                className: selectButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step3LevelSelect */Block.__(2, [45]));
                  })
              }, "Fortgeschritten"), React.createElement("button", {
                className: selectButton(/* () */0),
                onClick: (function () {
                    return Curry._1(send, /* Step3LevelSelect */Block.__(2, [60]));
                  })
              }, "Profi"), React.createElement("div", {
                className: inputHeaderText
              }, "Je nach Stufe liegt die Belastungszeit pro Übung bei 30, 45 oder 60 Sekunden."), React.createElement("div", {
                className: horizonBox
              }, React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxElSmall
                  }), React.createElement("div", {
                    className: horizonBoxEl
                  })));
      var step4 = React.createElement("div", {
            className: flexList
          }, React.createElement("h1", {
                className: inputHeaderHead
              }, "Jetzt kann's losgehen"), React.createElement("div", {
                className: rocketBox
              }, React.createElement("div", {
                    className: rocket
                  }, React.createElement("img", {
                        className: startIcon,
                        alt: "icon",
                        src: Start_iconSvg
                      }), React.createElement("img", {
                        className: startGas,
                        alt: "gas",
                        src: Start_gas_bgSvg
                      }))), React.createElement("div", {
                className: inputHeaderText
              }, "Du hast es geschafft. Dein Trainingsplan wurde nun erstellt. Im nächsten Step wird dir dieser mit den zugehörigen Workouts angezeigt."), React.createElement("button", {
                className: nextButton2(/* () */0),
                onClick: (function () {
                    return ReasonReact.Router[/* push */0]("/dashboard");
                  })
              }, "Starten"));
      var tmp;
      switch (step) {
        case "1" : 
            tmp = step1;
            break;
        case "2" : 
            tmp = step2;
            break;
        case "3" : 
            tmp = step3;
            break;
        case "4" : 
            tmp = step4;
            break;
        default:
          tmp = React.createElement("p", undefined, "no mapping");
      }
      return React.createElement("div", {
                  className: wizard
                }, tmp);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* weightInput */"",
              /* weight */0,
              /* imageSelect */0,
              /* levelSelect */0,
              /* loading : false */0,
              /* error : None */0,
              /* mySectionRef */[/* None */0]
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function () {
                            return ReasonReact.Router[/* push */0]("/wizard/2");
                          })]);
          case 2 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            var match = +(state[/* weight */1] > 36 && state[/* weight */1] < 200);
                            if (match !== 0) {
                              window.scrollTo(0, 0);
                              return ReasonReact.Router[/* push */0]("/wizard/2");
                            } else {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, ["Bitte Gewicht korrigieren"]));
                            }
                          })]);
          case 3 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            var match = +(state[/* imageSelect */2] > 0);
                            if (match !== 0) {
                              window.scrollTo(0, 0);
                              return ReasonReact.Router[/* push */0]("/wizard/3");
                            } else {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, ["Bitte Form selektieren"]));
                            }
                          })]);
          case 4 : 
              var newrecord = state.slice();
              return /* Update */Block.__(0, [(newrecord[/* error */5] = /* None */0, newrecord)]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var validInt = checkForInt(action[0]);
              return /* Update */Block.__(0, [/* record */[
                          /* weightInput */turnBackToString(validInt),
                          /* weight */validInt,
                          /* imageSelect */state[/* imageSelect */2],
                          /* levelSelect */state[/* levelSelect */3],
                          /* loading */state[/* loading */4],
                          /* error */state[/* error */5],
                          /* mySectionRef */state[/* mySectionRef */6]
                        ]]);
          case 1 : 
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* imageSelect */2] = action[0], newrecord$1)]);
          case 2 : 
              var newrecord$2 = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord$2[/* levelSelect */3] = action[0], newrecord$2),
                        (function (self) {
                            Network.safeWizardResultToLs(/* tuple */[
                                  self[/* state */2][/* weight */1],
                                  self[/* state */2][/* imageSelect */2],
                                  self[/* state */2][/* levelSelect */3]
                                ]);
                            window.scrollTo(0, 0);
                            return ReasonReact.Router[/* push */0]("/wizard/4");
                          })
                      ]);
          case 3 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* weightInput */state[/* weightInput */0],
                          /* weight */state[/* weight */1],
                          /* imageSelect */state[/* imageSelect */2],
                          /* levelSelect */state[/* levelSelect */3],
                          /* loading : false */0,
                          /* error : Some */[text],
                          /* mySectionRef */state[/* mySectionRef */6]
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */4);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.convToInt = convToInt;
exports.checkForInt = checkForInt;
exports.turnBackToString = turnBackToString;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/wizard.re
// module id = 112
// module chunks = 0